import React from 'react'
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts'
import styles from "../charts.module.css"

const ChartGauge = ({ value, color = "#7B61FF" }) => {
    const data = [{ name: "SLA", value }]

    if (value === 0) {
        return <div className={styles.emptyChartMessage}><p>Nenhum dado para exibir</p></div>
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <RadialBarChart
                innerRadius="70%"
                outerRadius="100%"
                data={data}
                startAngle={180}
                endAngle={0}
                margin={{ top: 18, right: 18, bottom: 0, left: 18 }}
            >
                <RadialBar
                    minAngle={15}
                    background={{ fill: "var(--surface-hover)" }}
                    clockWise
                    dataKey="value"
                    cornerRadius={15}
                    fill={color}
                />
                <text
                    x="50%"
                    y="55%"
                    textAnchor="middle"
                    dominantBaseline="central"
                    fontSize={22}
                    fontWeight="bold"
                    fill="var(--text-primary)"
                >
                    {value}%
                </text>
            </RadialBarChart>
        </ResponsiveContainer>
    )
}

export default ChartGauge
